const normalizeEmail = email => String(email || '').trim().toLowerCase();
export const accountKey = user => {
  if (!user?.id) throw new Error('Falta una cuenta verificada.');
  return `user_${user.id}`;
};
const legacyKey = email => `user_${String(email).replace(/[^a-zA-Z0-9]/g, '_')}`;
const RECORD_SUFFIXES = ['reto_start_date', 'selected_day', 'workout_plan', 'biomechanics_cache', 'body_logs', 'nutrition_logs', 'daily_steps', 'workout_logs', 'xp', 'photos'];
const parse = text => { try { return JSON.parse(text); } catch { return null; } };

export function readAccountProfile(user, storage = localStorage) {
  const profile = parse(storage.getItem(`${accountKey(user)}_profile`));
  if (!profile || profile.userId !== user.id) return null;
  return { ...profile, email: user.email, userId: user.id };
}
export function saveAccountProfile(user, profile, storage = localStorage) {
  const verified = { ...profile, email: user.email, userId: user.id };
  storage.setItem(`${accountKey(user)}_profile`, JSON.stringify(verified));
  storage.setItem(`${accountKey(user)}_profile_pending`, JSON.stringify(verified));
  if(typeof window !== 'undefined') window.dispatchEvent(new Event('profile-saved'));
  return verified;
}
export function prepareLocalAccount(user, storage = localStorage) {
  if (!user?.id || !user.email || !user.email_confirmed_at) throw new Error('Confirma tu correo para continuar.');
  const key = accountKey(user);
  const existing = readAccountProfile(user, storage);
  if (storage.getItem(`${key}_migration_complete`)) return existing;
  const active = parse(storage.getItem('active_user_profile'));
  const profiles = [];
  if (active?.email && !active.userId) profiles.push(active);
  for (let index = 0; index < storage.length; index++) {
    const name = storage.key(index);
    if (!name?.startsWith('user_') || !name.endsWith('_profile')) continue;
    const profile = parse(storage.getItem(name));
    if (profile?.email && !profile.userId) profiles.push(profile);
  }
  const matching = profiles.find(profile => normalizeEmail(profile.email) === normalizeEmail(user.email));
  const additions = [];
  const addMissing = (name, value) => {
    if (value === null || storage.getItem(name) !== null) return;
    storage.setItem(name, value); additions.push(name);
  };
  try {
    if (matching) {
      const oldKey = legacyKey(matching.email);
      // Legacy punctuation normalization could map two emails to the same namespace.
      const collision = profiles.some(p => legacyKey(p.email) === oldKey && normalizeEmail(p.email) !== normalizeEmail(user.email));
      if (collision) throw new Error('Los perfiles anteriores de este navegador comparten una clave. No hemos mezclado sus registros; hace falta revisar su recuperación.');
      for (const suffix of RECORD_SUFFIXES) addMissing(`${key}_${suffix}`, storage.getItem(`${oldKey}_${suffix}`));
      addMissing(`${key}_profile`, JSON.stringify({ ...matching, email: user.email, userId: user.id }));
    }
    // Never import simulated PRO, developer privileges or locally asserted subscriptions.
    addMissing(`${key}_migration_complete`, '1');
  } catch (error) {
    // Roll back this attempt only. Originals and any previously migrated records remain intact.
    for (const name of additions.reverse()) storage.removeItem(name);
    if (error.name === 'QuotaExceededError') throw new Error('No hay espacio para copiar los registros anteriores. Tus originales siguen intactos. Libera espacio en este navegador y vuelve a intentarlo.');
    throw error;
  }
  return readAccountProfile(user, storage);
}
export function resetAccountProgress(user, storage = localStorage) {
  const key = accountKey(user);
  for (const suffix of [...RECORD_SUFFIXES, 'trial_start_date']) storage.removeItem(`${key}_${suffix}`);
  // The import marker stays, so resetting cannot reimport old records on the next login.
}
